import axios from 'axios';
import { OCR_API_ENDPOINTS } from './types/OcrApiEndpoints';
const ACCOUNTING_ROUTE = `/accounting/ap`;
export var EApPlatform;
(function (EApPlatform) {
    EApPlatform["QBO"] = "QBO";
    EApPlatform["NETSUITE"] = "Netsuite";
    EApPlatform["XERO"] = "Xero";
    EApPlatform["MD365"] = "MD365";
    EApPlatform["BIGCHIP"] = "big-chip";
    EApPlatform["QBD"] = "QBD";
})(EApPlatform || (EApPlatform = {}));
export var EErpPlatform;
(function (EErpPlatform) {
    EErpPlatform["OPTIMUMCONTROL"] = "OC";
    EErpPlatform["MARKETMAN"] = "Marketman";
})(EErpPlatform || (EErpPlatform = {}));
export var EConfigurationType;
(function (EConfigurationType) {
    EConfigurationType["ApRutter"] = "apRutter";
    EConfigurationType["QBO"] = "QBO";
})(EConfigurationType || (EConfigurationType = {}));
export var ESyncDataType;
(function (ESyncDataType) {
    ESyncDataType["CHART_OF_ACCOUNT_DETAILS"] = "chartOfAccountDetails";
    ESyncDataType["LINE_ITEMS"] = "lineItems";
})(ESyncDataType || (ESyncDataType = {}));
/**
 *
 */
export async function updateOrderProduct(data) {
    const response = await axios.put(`${GATEWAY_API_HOST}/api/orders/${data.orderKey}/products/${data.productKey}/`, data).catch((error) => {
        if (error && error.message) {
            throw new Error(`Error updating line item: ${error.message}`);
        }
        throw error;
    });
    if (response.status === 200) {
        const jsonResult = await response.data;
        return jsonResult === null || jsonResult === void 0 ? void 0 : jsonResult.order;
    }
    throw Error(`Update order failed with status ${response.statusText}.`);
}
/**
 *
 */
export async function addOrderProduct(data) {
    const newOrder = Object.assign({}, data);
    const result = await axios.post(`${GATEWAY_API_HOST}/api/orders/${data.orderKey}/products/`, newOrder).catch((error) => {
        throw error;
    });
    if (result.status !== 200) {
        throw new Error(`Error adding product to order ${result.statusText}`);
    }
    return result.data;
}
/**
 *
 */
export async function deleteOrderProduct(data) {
    if (data.orderKey && data.productKey) {
        const resp = await axios.delete(`${GATEWAY_API_HOST}/api/orders/${data.orderKey}/products/${data.productKey}/`, { data: { forceDelete: true } }).catch((error) => {
            if (error && error.message) {
                throw new Error(`Error removing line item: ${error.message}`);
            }
            throw error;
        });
        return resp.data;
    }
    return null;
}
/**
 * Update invoice additional fee
 */
export async function updateAdditionalFee(orderKey, data) {
    if (!orderKey || !data.urlsafe) {
        throw new Error('Cannot update fee, orderKey or fee urlsafe do not exist.');
    }
    return axios.put(`${GATEWAY_API_HOST}/api/orders/${orderKey}/additional-fee/${data.urlsafe}/`, data);
}
/**
 *
 */
export async function updateOrderFields(orderKey, data) {
    return axios.put(`${GATEWAY_API_HOST}/api/orders/${orderKey}/`, data).catch((error) => {
        if (error && error.message) {
            throw new Error(`Error updating order fields: ${error.message}`);
        }
        throw error;
    });
}
/**
 *
 */
export async function updateOcrData(invoiceID, ocrParsedInvoiceData, ocrState, externalReferenceID) {
    const response = axios.patch(`${OCR_API_ENDPOINTS.OCR_API}/invoices/${invoiceID}`, { ocrState, ocrParsedInvoiceData, externalReferenceID }).catch((e) => {
        var _a, _b, _c;
        throw (_c = (_b = (_a = e.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) !== null && _c !== void 0 ? _c : e;
    });
    return response;
}
/**
 * Calls the catalog service to update prices
 * @param catalogID Catalog ID of the item to update
 * @param packageID Package ID of the item to update
 * @param priceListID Price list ID of the item to update or null if we want to update the default item
 * @param newPrice The price the item should be set to
 * @returns nothing
 */
export async function updatePrices(catalogID, packageID, priceListID, newPrice) {
    var _a;
    const response = await axios.get(`${OCR_API_ENDPOINTS.SECRET_SHOP_API}/supplierCatalogs/${catalogID}/products?packageID=${packageID}&limit=1`);
    const productResult = await response.data;
    if (((_a = productResult === null || productResult === void 0 ? void 0 : productResult.results) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        const product = productResult.results[0];
        const productID = product.id;
        const productPackage = product.packages[0];
        const { prices } = productPackage;
        let price = null;
        // iterate prices and see if any of them have our priceListID
        for (let i = 0; i < prices.length; i++) {
            if (prices[i].priceListID === null) {
                price = prices[i];
            }
            else if (prices[i].priceListID === priceListID) {
                price = prices[i];
                break;
            }
        }
        if (price) {
            const updatePriceResponse = await axios.patch(`${OCR_API_ENDPOINTS.SECRET_SHOP_API}/supplierCatalogs/${catalogID}/products/${productID}/packages/${packageID}/prices/${price.id}`, { pricePerUnit: newPrice });
            if (updatePriceResponse.status !== 200) {
                const errorText = updatePriceResponse.statusText;
                throw new Error(`Error updating catalog: ${errorText}`);
            }
            else {
                return updatePriceResponse.data;
            }
        }
        throw new Error(`Could not find price for ${OCR_API_ENDPOINTS.SECRET_SHOP_API}/supplierCatalogs/${catalogID}/products/${productID}/packages/${packageID}/prices/${price.id}`);
    }
    return null;
}
/**
 * Pulls only the prices matching a price list for products
 * If no prices are valid then the product will be filtered out
 */
function filterPriceListForProducts(products, priceListID) {
    return products
        .map((product) => (Object.assign(Object.assign({}, product), { packages: product.packages
            .map((productPackage) => (Object.assign(Object.assign({}, productPackage), { prices: productPackage.prices
                .filter((price) => price.priceListID === null || price.priceListID === priceListID)
                .sort((price) => (price.priceListID ? -1 : 1))
                .slice(0, 1)
                .filter((price) => price.available) })))
            .filter(({ prices }) => prices.length > 0) })))
        .filter(({ packages }) => packages.length > 0);
}
/**
 * Search a catalog by search term and then filter pricing info for a specific price list
 */
export async function searchCatalogByTerm(secretShopApi, supplierCatalogID, searchTerm, priceListID) {
    const response = await axios.get(`${secretShopApi}/supplierCatalogs/${supplierCatalogID}/products?limit=25&searchTerm=${searchTerm}`);
    const responseJSON = response.data;
    return Object.assign(Object.assign({}, responseJSON), { results: filterPriceListForProducts(responseJSON.results, priceListID) });
}
/**
 * Search catalog by providing sourceUUID coming from be-core
 */
export async function searchCatalogByPackageID(catalogID, packageID, priceListID) {
    var _a;
    const response = await axios.get(`${SECRET_SHOP_API}/supplierCatalogs/${catalogID}/products?limit=25&packageID=${packageID}`);
    return filterPriceListForProducts((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.results, priceListID);
}
/**
 * Search catalog for an exact sku match
 * @param secretShopUrl The url of the secret shop to search
 * @param buyerUrlsafeKey The urlsafe for the buyer to search for (will only search catalogs this buyer can see)
 * @param productSku The sku of the product to match
 * @param catalogID An optional catalog ID to restrict the search only to a single catalog ID
 * @returns An IPackage if found or null if not found
 */
export async function getCatalogProductForSku(productSku, catalogID, priceListID) {
    const searchResults = await searchCatalogByTerm(OCR_API_ENDPOINTS.SECRET_SHOP_API, catalogID, productSku, priceListID);
    if (searchResults.results.length > 0) {
        for (let i = 0; i < searchResults.results.length; i++) {
            const foundProduct = searchResults.results[i];
            const { taxCode } = foundProduct;
            const foundPackages = foundProduct.packages;
            for (let j = 0; j < foundPackages.length; j++) {
                const curPackage = foundPackages[j];
                curPackage.taxCode = taxCode;
                if (curPackage.sku === productSku) {
                    return curPackage;
                }
            }
        }
    }
    return null;
}
/**
 * Called to add a new product to the catalog system. Will add a new null and unavailable price if there isn't one already.
 */
export async function addNewItemtoCatalog({ catalogID, productSku, priceListID, product }) {
    // first see if this catalog has a default price
    const newProduct = Object.assign({}, product);
    const foundPackage = await getCatalogProductForSku(productSku, catalogID, priceListID);
    // if we found a package then we know there already exists a default for this sku. If not then we need to add a new default price
    // as well and set it's availability to false. Also, if the priceListID sent in is null then we don't need to do this either.
    if (!foundPackage && product.packages[0].prices[0].priceListID) {
        const foundPrice = newProduct.packages[0].prices[0];
        const newPrice = Object.assign({}, foundPrice);
        newPrice.available = false;
        newPrice.priceListID = undefined;
        // put the unavailable first
        newProduct.packages[0].prices.unshift(newPrice);
    }
    const response = await axios.post(`${OCR_API_ENDPOINTS.SECRET_SHOP_API}/supplierCatalogs/${catalogID}/products`, newProduct);
    return response.data;
}
/**
 *
 */
export async function getOcrCatalogData(buyerKey) {
    return axios.get(`${SECRET_SHOP_API}/buyers/${buyerKey}/supplierCatalogs`).then((r) => r.data);
}
/**
 * Delete the OCR record
 */
export async function deleteOcrInvoice(falsePromiseID) {
    return axios.delete(`${OCR_API_ENDPOINTS.OCR_API}/invoices/${falsePromiseID}`).then((resp) => resp.data);
}
/**
 * Fetch GL Codes for the input buyer
 */
export async function getGLCodesData(platform, buyerUrlsafeKey, accessToken) {
    return axios.get(`${OCR_API_ENDPOINTS.BUSHWHACK_API}${ACCOUNTING_ROUTE}/${platform}/glAccounts/buyer/${buyerUrlsafeKey}`, { params: { accessToken } }).then((response) => response.data);
}
/**
 * Fetch GL Codes <> SKU Mappings
 */
export async function getGLCodeSKUMappings(platform, buyerUrlsafeKey, supplierUrlsafeKey, accessToken) {
    return axios.get(`${OCR_API_ENDPOINTS.BUSHWHACK_API}${ACCOUNTING_ROUTE}/${platform}/sku/supplier/${supplierUrlsafeKey}/buyer/${buyerUrlsafeKey}`, { params: { accessToken } }).then((response) => response.data);
}
/**
 * Fetch GL Codes <> Categories Mappings
 */
export async function getGLCodeCategoriesMappings(platform, buyerUrlsafeKey, accessToken) {
    return axios.get(`${OCR_API_ENDPOINTS.BUSHWHACK_API}${ACCOUNTING_ROUTE}/${platform}/product/mapping/buyer/${buyerUrlsafeKey}`, { params: { accessToken } }).then((response) => response.data);
}
/**
 * Fetch Accounting info including accounting periods for the input buyer
 */
export async function getAccountingInfo(platform, buyerUrlsafeKey, accessToken) {
    return axios.get(`${OCR_API_ENDPOINTS.BUSHWHACK_API}${ACCOUNTING_ROUTE}/${platform}/accountinginfo/buyer/${buyerUrlsafeKey}`, { params: { accessToken } }).then((response) => response.data);
}
/**
 * Fetch Accounting Classes for the input buyer
 */
export async function getAccountingClasses(platform, buyerUrlsafeKey, accessToken) {
    if (platform === EApPlatform.MD365) {
        // MD365 does not support classes
        return { classes: [] };
    }
    return axios.get(`${OCR_API_ENDPOINTS.BUSHWHACK_API}${ACCOUNTING_ROUTE}/${platform}/classes/buyer/${buyerUrlsafeKey}`, { params: { accessToken } }).then((response) => response.data);
}
/**
 * Fetch Accounting Vendors for the input buyer
 */
export async function getAccountingVendorsData(platform, buyerUrlsafeKey, accessToken) {
    return axios.get(`${OCR_API_ENDPOINTS.BUSHWHACK_API}${ACCOUNTING_ROUTE}/${platform}/vendors/buyer/${buyerUrlsafeKey}`, { params: { accessToken } }).then((response) => response.data);
}
/**
 * Fetch the Notch Supplier <> Accounting Vendor mapping from bushwhack to get the Accounting vendor id
 */
export async function getAccountingVendorMapped(platform, buyerUrlsafeKey, supplierUrlsafeKey, accessToken) {
    return axios.get(`${OCR_API_ENDPOINTS.BUSHWHACK_API}${ACCOUNTING_ROUTE}/${platform}/vendors/${supplierUrlsafeKey}/buyer/${buyerUrlsafeKey}`, { params: { accessToken } }).then((response) => response.data);
}
/**
 * Create a new Accounting vendor using the basic vendor data: name and email
 */
export async function createAccountingVendor(platform, buyerUrlsafeKey, supplierUrlsafeKey, supplierName, supplierEmail, accessToken) {
    return axios.post(`${OCR_API_ENDPOINTS.BUSHWHACK_API}${ACCOUNTING_ROUTE}/${platform}/vendors/buyer/${buyerUrlsafeKey}`, {
        supplierUrlsafeKey,
        supplierName,
        supplierEmail,
    }, { params: { accessToken } }).then((response) => response.data);
}
/**
 * Fetch Tax Codes for the input buyer
 */
export async function getTaxCodesData(platform, buyerUrlsafeKey, accessToken) {
    return axios.get(`${OCR_API_ENDPOINTS.BUSHWHACK_API}${ACCOUNTING_ROUTE}/${platform}/taxcodes/buyer/${buyerUrlsafeKey}`, { params: { accessToken } }).then((response) => response.data);
}
export async function getAccountingConfiguration(buyerUrlsafeKey) {
    const url = `${OCR_API_ENDPOINTS.BUSHWHACK_API}${ACCOUNTING_ROUTE}/configurations/buyer/${buyerUrlsafeKey}`;
    const response = await axios.get(url);
    return response.data;
}
export async function getOrderData(orderKey) {
    return axios.get(`${OCR_API_ENDPOINTS.GATEWAY_API_HOST}/api/orders/${orderKey}`).then((response) => response.data);
}
export async function fetchBuyer(buyerKey) {
    const endpoint = `${OCR_API_ENDPOINTS.BASE_API_V3}/buyers/${buyerKey}?buyerKey=${buyerKey}`;
    return axios.get(endpoint).then((response) => response.data);
}
export async function fetchSupplier(supplierUrlsafeKey, buyerKey) {
    const endpoint = `${OCR_API_ENDPOINTS.BASE_API_V3}/vendors/${supplierUrlsafeKey}?buyerKey=${buyerKey}`;
    return axios.get(endpoint).then((response) => response.data);
}
/**
 * Get greevils greed invoices for buyer with supplier.
 */
export async function getGreevilsInvoices(buyerUrlsafeKey, supplierUrlsafeKey, invoiceNumber) {
    const params = {
        limit: 1000,
        buyerUrlsafeKey,
        supplierUrlsafeKey,
        invoiceNumber,
    };
    return axios.get(`${OCR_API_ENDPOINTS.GREEVILS_GREED_API}/invoices`, { params }).then((resp) => { var _a, _b; return (_b = (_a = resp.data) === null || _a === void 0 ? void 0 : _a.results) !== null && _b !== void 0 ? _b : []; });
}
/**
 * Get resource sync details.
 */
export async function getResourceSyncDetails(buyerUrlsafeKey, syncIds) {
    var _a;
    const joinedIds = syncIds.join();
    const url = `${OCR_API_ENDPOINTS.BUSHWHACK_API}/resources/status?buyerUrlsafeKey=${buyerUrlsafeKey}`;
    const response = await axios.post(url, { ids: joinedIds });
    return (_a = response.data) === null || _a === void 0 ? void 0 : _a.statuses;
}
//# sourceMappingURL=OcrNetwork.js.map